// Module
var code = "<div class=file-upload-wrapper><div class=upload-container><h3><i class=\"fa fa-picture-o fa-lg-indent\"></i>Click<span class=hidden-xs>&nbsp;or Drag</span>&nbsp;to Upload</h3></div></div>";
// Exports
module.exports = code;